import React from "react";
import { T } from "@/lib/copy";
import { localDate } from "@/lib/api"; // B48: for played-today badge lookup.

// Pick your chase / opponent — ported 1:1 from /design rOpponent(). Uniform .diff cards, no icons.
const ORDER = ["casual", "diehard", "aspiring"];

export default function PickChase({ lang, personas, onPick, onMeet, challenger, meetSeen = false }) {
  const t = T(lang);
  // B48: check if persona already played today (localStorage-scoped by local_date).
  const isPlayed = (key) => { try { return localStorage.getItem(`so_played_${key}_${localDate()}`) === "1"; } catch (e) { return false; } };
  return (
    <div className="dpick" style={{ padding: "26px 22px 22px", display: "flex", flexDirection: "column", minHeight: "100%" }} data-testid="pick-screen">
      <div className="pick-headline">{t.pickTitle}</div>

      {onMeet && (
        <button className={"btn-meet" + (meetSeen ? " seen" : "")} style={{ marginTop: 14 }} onClick={onMeet} data-testid="pick-meet-maidaan-button">
          {t.meet}
        </button>
      )}

      {challenger && (
        <div className="panel anim-fade" style={{ marginTop: 12, padding: 10, textAlign: "center" }} data-testid="pick-challenger-panel">
          <div className="font-reading" style={{ fontSize: 12, color: "rgba(244,239,230,0.85)" }}>
            {challenger.challenger_name} got <b style={{ color: "var(--sm-blaze)" }}>{challenger.challenger_score}</b> — pick your lens and beat it.
          </div>
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 9, marginTop: 16 }}>
        {ORDER.map((key) => {
          const p = personas[key];
          if (!p) return null;
          const locked = challenger && challenger.persona && challenger.persona !== key;
          return (
            <button key={key} className="diff" style={{ opacity: locked ? 0.45 : 1 }} disabled={locked}
                    onClick={() => onPick(key)} data-testid={`persona-${key}-card`}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="who">{p.name}</div>
                <div className="feel">{typeof p.tagline === "string" ? p.tagline : (p.tagline?.[lang] || p.tagline?.en || "")}</div>
                {isPlayed(key) && (
                  <div data-testid={`persona-${key}-played-badge`} style={{ fontFamily: '"Spline Sans Mono", monospace', fontSize: 9, letterSpacing: "0.14em", color: "var(--sm-blaze)", marginTop: 4, opacity: 0.75, textTransform: "uppercase" }}>✓ Played · Fresh tomorrow</div>
                )}
              </div>
              <div style={{ textAlign: "right", flex: "none" }}>
                <div className="chase">{p.chase}</div>
                <div className="chase-cap">{t.toChase}</div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
